// extracted by mini-css-extract-plugin
export var button = "FooterNav-module--button--861da";
export var contentWrapper = "FooterNav-module--content-wrapper--9f884";
export var footerNav = "FooterNav-module--footer-nav--fed92";
export var icon = "FooterNav-module--icon--717d7";
export var open = "FooterNav-module--open--0fe7d";